import React, { useEffect } from 'react';
import { observer } from 'mobx-react-lite';
import { AppButton, AppTimePicker } from '@pro-sto/ui';
import { operatingHoursStore, shiftViewStore } from '@/stores';
import { parseDateParam, plannedTimeWindow } from '../ShiftsWeek/shiftWeekModel';

const ShiftTimeModal: React.FC = observer(() => {
  const open = shiftViewStore.timeModalMemberUuid !== null;

  useEffect(() => {
    if (!open) return;
    const previous = document.body.style.overflow;
    document.body.style.overflow = 'hidden';
    return () => {
      document.body.style.overflow = previous;
    };
  }, [open]);

  if (!open) return null;

  const timeZone = operatingHoursStore.timezone || 'Europe/Moscow';
  const shiftDate = shiftViewStore.detail?.date.slice(0, 10);
  const timeSlots = shiftDate
    ? plannedTimeWindow(
        parseDateParam(shiftDate),
        operatingHoursStore.regularSchedule,
        operatingHoursStore.specialDates,
      )?.slots
    : undefined;

  return (
    <div className="shift-time-modal" role="presentation" data-testid="shift-time-modal">
      <div
        className="shift-time-modal__window"
        role="dialog"
        aria-modal="true"
        aria-labelledby="shift-time-modal-title"
      >
        <h2 className="shift-time-modal__title" id="shift-time-modal-title">
          Изменить время
        </h2>
        <p className="shift-time-modal__hint">
          В списке — график центра. Можно ввести другое время вручную в пределах суток смены.
        </p>
        <div className="shift-time-modal__fields">
          <AppTimePicker
            label="Начало"
            value={shiftViewStore.timeStart}
            onChange={(value) => shiftViewStore.setTimeStart(value)}
            disabled={shiftViewStore.isSavingTime}
            availableSlots={timeSlots}
            data-testid="shift-time-start"
          />
          <AppTimePicker
            label="Конец"
            value={shiftViewStore.timeEnd}
            onChange={(value) => shiftViewStore.setTimeEnd(value)}
            disabled={shiftViewStore.isSavingTime}
            availableSlots={timeSlots}
            data-testid="shift-time-end"
          />
        </div>
        {shiftViewStore.timeError ? (
          <p className="shift-day__error-message" data-testid="shift-time-error">
            {shiftViewStore.timeError}
          </p>
        ) : null}
        <div className="shift-time-modal__actions">
          <AppButton
            variant="secondary"
            onClick={() => shiftViewStore.closeTimeModal()}
            disabled={shiftViewStore.isSavingTime}
            data-testid="shift-time-cancel"
          >
            Отмена
          </AppButton>
          <AppButton
            variant="primary"
            loading={shiftViewStore.isSavingTime}
            onClick={() => shiftViewStore.saveActualTime(timeZone)}
            data-testid="shift-time-save"
          >
            Сохранить
          </AppButton>
        </div>
      </div>
    </div>
  );
});

ShiftTimeModal.displayName = 'ShiftTimeModal';

export default ShiftTimeModal;
